import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { PerformanceTestComponent } from './performance-test/performance-test.component';
import { QueueComponent } from './queue/queue.component';
import { PerformanceResultsComponent } from './performance-results/performance-results.component';
import { PerformanceLoadTestingComponent } from './performance-load-testing/performance-load-testing.component';
import { CompareResultsComponent } from './compare/compare-results/compare-results.component';
import { CompareComponent } from './compare/compare.component';
import { NewPerformanceResultPageComponent } from '@app/new-performance-page/new-performance-result-page/new-performance-result-page.component';
import { NewPerformanceCompareComponent } from '@app/new-performance-page/new-performance-compare/new-performance-compare.component';
import { NewPerformanceQueueComponent } from '@app/new-performance-page/new-performance-queue/new-performance-queue.component';
import { NewPerformanceJmxUploadComponent } from '@app/new-performance-page/new-performance-jmx-upload/new-performance-jmx-upload.component';
import { PerformanceLabOverviewComponent } from '@app/_shared/overview/performance-lab-overview/performance-lab-overview.component';


const routes: Routes = [
    { path: '', component: PerformanceLabOverviewComponent },
    {
        path: 'loadTesting',
        component: PerformanceLoadTestingComponent,
        children: [
            { path: '', component: PerformanceTestComponent },
            { path: 'rerun/:id', component: PerformanceTestComponent },
            { path: 'result/:id', component: PerformanceResultsComponent },
            { path: 'new-result/:id', component: NewPerformanceResultPageComponent },
            { path: 'result/:id/queue', component: PerformanceResultsComponent },
            { path: 'new-result/:id/queue', component: NewPerformanceResultPageComponent },
            { path: 'queue', component: NewPerformanceQueueComponent },
            { path: 'compare', component: NewPerformanceCompareComponent },
            { path: 'compare-results', component: CompareResultsComponent },
            { path: 'jmx-upload', component: NewPerformanceJmxUploadComponent },
            { path: 'jmx-upload/:id', component: NewPerformanceJmxUploadComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PerformanceRoutingModule { }
